<template>
    <v-layout class="mt-3">
        <v-flex xs12>
            <v-card class="mx-aut" flat>
                <confirmation-header-text text="Relationship visa details" class="ml-2"
                                          icon="mdi-account-multiple"></confirmation-header-text>

                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs6 class="pr-2">
                            <v-autocomplete
                                outlined
                                label="Relation with kin"
                                :items="relations"
                                v-model="visa.extra.application_data.relation"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field
                                outlined
                                label="Name of kin"
                                v-model="visa.extra.extra_traveller.full_name"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6 class="pr-2">
                            <v-autocomplete
                                :items="genders"
                                outlined
                                label="Gender of kin"
                                v-model="visa.extra.extra_traveller.gender"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6>
                            <address-auto-complete
                                label="Full address"
                                v-model="visa.extra.extra_traveller.full_address"
                            ></address-auto-complete>
                        </v-flex>
                        <v-flex class="pr-2" sm6 xs12>
                            <v-text-field
                                label="Citizenship number"
                                outlined
                                type="text"
                                v-model="visa.extra.extra_traveller.document_number"
                            ></v-text-field>
                        </v-flex>
                        <v-flex sm6 xs12 class="pl-4 pr-2">
                            <date-picker-nepali
                                label="Date of birth (BS)"
                                v-model="visa.extra.extra_traveller.dob"
                                :min-year="dob.min_year"
                                :max-year="dob.max_year"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import FileInput from "../../FileInput";
    import {mapActions} from 'vuex';
    import {fetchDynamicValues} from "../../../helpers/dynamicValueHelper";
    import NewDatePicker from "../../NewDatePicker";
    import DatePickerNepali from "../../DatePickerNepali";


    export default {
        data: () => ({
            genders: ['Male', 'Female'],
            rules: {
                required: value => !!value || "Required."
            },
            relations: [],
            options: [
                {
                    text: "Nepal",
                    value: "Nepal"
                },
                {
                    text: "Abroad",
                    value: "Abroad"
                }
            ]
        }),
        components: {
            DatePickerNepali,
            NewDatePicker,
            // DatePicker,
            FileInput, ConfirmationHeaderText,
            "address-auto-complete": AddressAutoComplete
        },
        computed: {
            visa() {
                return this.$store.state.VisaRequestSingle.visaRequest;
            },
            dob() {
                const max_year = (new Date().getFullYear() + 52);
                const min_year = max_year - 120;

                return {
                    max_year,
                    min_year
                }
            }
        },
        methods: {
            ...mapActions('DynamicValues', ['fetchDynamicValues']),
            addressChanged(e) {
                this.visa.extra.application_data.address = e;
            },
            getDynamicLabel(text) {
                if (this.visa.extra.application_data.full_name) {
                    return text + ' of ' + this.visa.extra.application_data.full_name + ' *'
                } else if (this.visa.extra.application_data.married_to) {
                    return text + ' of ' + this.visa.extra.application_data.married_to + ' *'
                } else {
                    return text + ' of Husband/Wife *'
                }
            },
        },
        mounted() {
            fetchDynamicValues('Relations').then((res) => {
                this.relations = res;
            })
        }
    };
</script>
